import { render } from "./AdminTrackApprovedRequest.vue?vue&type=template&id=15991ca2"
import script from "./AdminTrackApprovedRequest.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__